/**
 * Role Refactor (P-8) — client-side role helpers.
 * Onboarding admin portal is super_admin-only (platform operator); no app_registry module.
 */

export function isPlatformSuperAdmin(user) {
  return user?.role === 'super_admin';
}

export function canAccessOnboardingAdmin(user) {
  if (!user) return false;
  if (isPlatformSuperAdmin(user)) return true;
  // Legacy JWT fallback until natural expiry (R-Q6)
  return user.role === 'super_admin';
}
